/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_Too_Many_RequestsInputs */

const en_us2_invite_too_many_requests = /** @type {(inputs: Invite_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Too many tries in a short time. Try again tomorrow.`)
};

const pt_br2_invite_too_many_requests = /** @type {(inputs: Invite_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas tentativas em pouco tempo. Tente de novo amanhã.`)
};

const pt_pt2_invite_too_many_requests = /** @type {(inputs: Invite_Too_Many_RequestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muitas tentativas em pouco tempo. Tente de novo amanhã.`)
};

/** @type {(inputs: Invite_Too_Many_RequestsInputs) => LocalizedString} */
const es_419_invite_too_many_requests = en_us2_invite_too_many_requests;

/** @type {(inputs: Invite_Too_Many_RequestsInputs) => LocalizedString} */
const fr_fr2_invite_too_many_requests = en_us2_invite_too_many_requests;

/** @type {(inputs: Invite_Too_Many_RequestsInputs) => LocalizedString} */
const de_de2_invite_too_many_requests = en_us2_invite_too_many_requests;

/** @type {(inputs: Invite_Too_Many_RequestsInputs) => LocalizedString} */
const it_it2_invite_too_many_requests = en_us2_invite_too_many_requests;

/**
* | output |
* | --- |
* | "Too many tries in a short time. Try again tomorrow." |
*
* @param {Invite_Too_Many_RequestsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_too_many_requests = /** @type {((inputs?: Invite_Too_Many_RequestsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_Too_Many_RequestsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_too_many_requests(inputs)
	if (locale === "es-419") return es_419_invite_too_many_requests(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_too_many_requests(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_too_many_requests(inputs)
	if (locale === "de-DE") return de_de2_invite_too_many_requests(inputs)
	if (locale === "it-IT") return it_it2_invite_too_many_requests(inputs)
	return en_us2_invite_too_many_requests(inputs)
});
export { invite_too_many_requests as "invite.too_many_requests" }